import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import permissions from './submodules/permissions';
import groups from './submodules/groups';

const state = {
    users: [],
    users_count: 0,
    users_filters: { offset: 0, limit: 20, myentity: true, ordering: 'full_name' },
    users_loading: false,
    users_loading_errors: null,
    users_cancel_source: null,
};

const mutations = {
    updateUsers(state, users) {
        state.users = users;

    },
    updateUsersFilters(state, filters) {
        state.users_filters = filters;
    },
    updateUsersCount(state, count) {
        state.users_count = count;
    },
    updateUsersLoading(state, loading) {
        state.users_loading = loading;
    },
    updateUsersLoadingErrors(state, errors) {
        state.users_loading_errors = errors;
    },
    updateUsersCancelSource(state, cancel_source) {
        state.users_cancel_source = cancel_source;
    },
};

const actions = {
    init({ commit, dispatch, state }, params) {
        dispatch('permissions/init', { profile: params.profile });
        dispatch('permissions/fetchPermissions');
        dispatch('groups/init', { filters: { for_entity: params.entity } });
        dispatch('groups/fetchGroups');
    },

    async fetchUsers({ commit, dispatch, state }, params) {
        commit('updateUsersLoading', true);
        commit('updateUsersLoadingErrors', null);

        if (state.users_cancel_source) {
            state.users_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateUsersCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/users/', {
                params: state.users_filters,
                cancelToken: state.users_cancel_source?.token
            });
            commit('updateUsers', response.data.results);
            commit('updateUsersCount', response.data.count);
            commit('updateUsersCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateUsersLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateUsersLoading', false);
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        groups: groups(),
        permissions: permissions(),
    }
};
